import {Injectable} from '@angular/core';
import {Observable, catchError} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {DataService} from '../data.service';
import {LoggerService} from '../../shared/common-components/logger.service';


@Injectable({
  providedIn: 'root'
})
export class OrganizationuserService extends DataService {

  private baseURI = this.apiUri + '/organizationuserrole/';
  private observable$: any;
  private _logger: LoggerService;

  constructor(http: HttpClient, logger: LoggerService) {
    super(http);
    this._logger = logger;
  }

  getOrganizationUserByEmail(email): Observable<any> {
    this.setUri(this.baseURI + email);
    this.observable$ = this.http.get(this.baseURI + email).pipe(catchError(this.handleError));
    return this.observable$;
  }
}
